/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import accounting from 'accounting'

const DATE_FORMAT = 'MM/DD/YYYY';

const Row = ({data}) => {
  let {
    PAID, INVOICE_ID, RECEIVED_DATE, SCHEDULED_PAY_DATE, CHECK_NO
  } = data;

  if(!SCHEDULED_PAY_DATE){
    SCHEDULED_PAY_DATE = 'In Progress'
  } else {
    SCHEDULED_PAY_DATE = moment(new Date(SCHEDULED_PAY_DATE)).format(DATE_FORMAT);
  }

  if(!PAID){
    PAID = '';
  } else {
    PAID = accounting.formatMoney(PAID,"$",0);
  }

  RECEIVED_DATE = moment(new Date(RECEIVED_DATE)).format(DATE_FORMAT);
  return (
    <tr>
      <td>{RECEIVED_DATE}</td>
      <td>{INVOICE_ID}</td>
      <td>{SCHEDULED_PAY_DATE}</td>
      <td>{CHECK_NO}</td>
      <td style={{textAlign:'right'}}>{PAID}</td>
    </tr>
  )
};

Row.propTypes = {};
Row.defaultProps = {};

export default Row;


// WEBPACK FOOTER //
// ./src/components/Payments/Row.jsx